function init() {
  var $navLink;

  if($('.menu-list .has-child').length < 1) return;

  $navLink = $('.has-child > a');

  if($navLink.parent().hasClass('expanded')){
    $navLink.parent().find('> ul').stop().slideDown();
  }

  $navLink.click(function(e) {
    e.preventDefault();
    var myThis = $(this);
    $(this).parent().toggleClass('expanded');
    myThis.parent().find('> ul').stop().slideToggle();
  })
}

$(function() {
  init();
})